module.exports = __webpack_public_path__ + "assets/img/img1.7b439208.png";